module.exports = __webpack_public_path__ + "img/tar.6d8e2f26.png";